const initializeRydeStoryVideos = (scope = document) => {
  if (document.documentElement.dataset.storyEscapeBound !== 'true') {
    document.documentElement.dataset.storyEscapeBound = 'true';
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const playingVideos = [...document.querySelectorAll('[data-story-video]')]
        .filter((video) => !video.paused && !video.ended);
      if (!playingVideos.length) return;

      event.preventDefault();
      for (const video of playingVideos) {
        video.pause();
        const button = video.closest('[data-story-media]')?.querySelector('[data-story-play]');
        const label = video.getAttribute('aria-label') || 'customer story';
        button?.setAttribute('aria-pressed', 'false');
        button?.setAttribute('aria-label', `Play ${label}`);
      }
      playingVideos[0].closest('[data-story-media]')?.querySelector('[data-story-play]')?.focus();
    });
  }

  const videos = [
    ...(scope.matches?.('[data-story-video]') ? [scope] : []),
    ...scope.querySelectorAll('[data-story-video]'),
  ];

  for (const video of videos) {
    if (video.dataset.storyVideoInitialized === 'true') continue;
    video.dataset.storyVideoInitialized = 'true';

    const activateSource = () => {
      const configuredSource = video.dataset.videoSrc;
      if (!configuredSource || video.src) return;
      video.src = configuredSource.startsWith('/cdn/videos/')
        ? configuredSource.replace('/cdn/', 'https://cdn.shopify.com/')
        : configuredSource;
      video.load();
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        activateSource();
        observer.disconnect();
      }, { rootMargin: '500px 0px' });
      observer.observe(video);
    } else {
      activateSource();
    }

    const media = video.closest('[data-story-media]');
    const button = media?.querySelector('[data-story-play]');
    if (!media || !button) continue;

    const label = video.getAttribute('aria-label') || 'customer story';
    const sync = () => {
      const playing = !video.paused && !video.ended;
      button.setAttribute('aria-pressed', String(playing));
      button.setAttribute('aria-label', `${playing ? 'Pause' : 'Play'} ${label}`);
    };
    const pause = () => {
      video.pause();
      sync();
    };
    const toggle = () => {
      if (!video.paused && !video.ended) {
        pause();
        return;
      }

      for (const otherVideo of document.querySelectorAll('[data-story-video]')) {
        if (otherVideo !== video) otherVideo.pause();
      }
      activateSource();
      video.play().then(sync).catch(sync);
    };

    button.addEventListener('click', toggle);
    video.addEventListener('click', toggle);
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    video.addEventListener('ended', sync);
    sync();
  }
};

document.addEventListener('DOMContentLoaded', () => initializeRydeStoryVideos());
document.addEventListener('shopify:section:load', (event) => initializeRydeStoryVideos(event.target));
